
import {
  GET_HORSE_RACE_SELECTED_HORSES,
  GET_HORSE_RACE_SELECTED_HORSES_SUCCESS,
  GET_HORSE_RACE_SELECTED_HORSES_FAILURE,
} from 'Store/constants';

const initialState = {
  selectedHorses: [],
  relatedHippodrome: null,
  isLoading: true,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HORSE_RACE_SELECTED_HORSES:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACE_SELECTED_HORSES_SUCCESS:
      return { ...state, selectedHorses: action.payload.selectedHorses, relatedHippodrome: action.payload.relatedHippodrome, isLoading: false, error: null };
    case GET_HORSE_RACE_SELECTED_HORSES_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};